// Skill-roll rarity, from Fuelax's Class Formulas sheet
// (data in src/data/skillRarity.json: { [name]: { p, s? } }).
//
// p = chance a skill is rolled when it's the unit's OWN class (primary),
// s = chance when the class is taken as a secondary skillset. Lower = rarer.
//
// Tiers are keyed on the PRIMARY % (intrinsic rarity). s is ~5 below p across
// the board, and the secondary baseline sits at 35 — so tiering on the
// contextual % would light up nearly every secondary skill. We instead color
// by intrinsic tier and DISPLAY the context-correct % (p for own-class skills,
// s for the secondary set). Common skills (p >= 40) and skills absent from the
// sheet (monster skills, reaction/support/move) are unmarked.

// max is inclusive; first matching tier wins. >= 40 -> common (null).
//   color — bright, for use on dark backgrounds.
//   pill  — darker fill that stays legible with white text on light backgrounds.
export const RARITY_TIERS = [
  { key: 'legendary', label: 'Legendary', max: 12, color: '#f0b429', pill: '#b07d0a' }, // gold
  { key: 'rare',      label: 'Rare',      max: 24, color: '#6aa3ff', pill: '#2f6fd0' }, // blue
  { key: 'uncommon',  label: 'Uncommon',  max: 39, color: '#35c39a', pill: '#1f8e6c' }, // teal
];

export function tierForPrimary(p) {
  if (typeof p !== 'number') return null;
  for (const t of RARITY_TIERS) if (p <= t.max) return t;
  return null;
}

// Returns { tier, roll, p, s } for a highlightable skill, else null.
//   isSecondary — true when the skill came from the unit's secondary set.
//   rarityMap   — the skillRarity.json object.
export function skillRarity(name, isSecondary, rarityMap) {
  const rec = rarityMap && rarityMap[name];
  if (!rec) return null;
  const tier = tierForPrimary(rec.p);
  if (!tier) return null;
  const roll = isSecondary && typeof rec.s === 'number' ? rec.s : rec.p;
  return { tier, roll, p: rec.p, s: rec.s };
}
